__turbopack_context__.v({
  "error": "items-form-block1440px-module-scss-module__G74u1W__error",
  "errorText": "items-form-block1440px-module-scss-module__G74u1W__errorText",
  "form": "items-form-block1440px-module-scss-module__G74u1W__form",
  "formblock": "items-form-block1440px-module-scss-module__G74u1W__formblock",
  "icon": "items-form-block1440px-module-scss-module__G74u1W__icon",
  "icon5": "items-form-block1440px-module-scss-module__G74u1W__icon5",
  "item1": "items-form-block1440px-module-scss-module__G74u1W__item1",
  "item11": "items-form-block1440px-module-scss-module__G74u1W__item11",
  "item2": "items-form-block1440px-module-scss-module__G74u1W__item2",
  "items": "items-form-block1440px-module-scss-module__G74u1W__items",
  "label": "items-form-block1440px-module-scss-module__G74u1W__label",
  "leftcol": "items-form-block1440px-module-scss-module__G74u1W__leftcol",
  "lookingForA": "items-form-block1440px-module-scss-module__G74u1W__lookingForA",
  "lookingformblock1440px": "items-form-block1440px-module-scss-module__G74u1W__lookingformblock1440px",
  "rightcol": "items-form-block1440px-module-scss-module__G74u1W__rightcol",
  "row": "items-form-block1440px-module-scss-module__G74u1W__row",
  "tellUsWhat": "items-form-block1440px-module-scss-module__G74u1W__tellUsWhat",
  "tellUsWhatContainer": "items-form-block1440px-module-scss-module__G74u1W__tellUsWhatContainer",
  "text": "items-form-block1440px-module-scss-module__G74u1W__text",
  "text1": "items-form-block1440px-module-scss-module__G74u1W__text1",
  "text6": "items-form-block1440px-module-scss-module__G74u1W__text6",
  "textField": "items-form-block1440px-module-scss-module__G74u1W__textField",
  "wrapper": "items-form-block1440px-module-scss-module__G74u1W__wrapper",
});
